import { TrendUp01, TrendDown01, ArrowRight } from "@untitledui/icons";

export function formatCompanyProfileCurrency(value: number): string {
    if (value >= 1_000_000) {
        return `$${(value / 1_000_000).toFixed(1)}M`;
    }
    if (value >= 1000) {
        return `$${(value / 1000).toFixed(0)}K`;
    }
    return `$${value.toFixed(0)}`;
}

export function formatCompanyProfileNumber(value: number): string {
    if (value >= 1_000_000) {
        return `${(value / 1_000_000).toFixed(1)}M`;
    }
    if (value >= 1000) {
        return `${(value / 1000).toFixed(0)}K`;
    }
    return value.toLocaleString();
}

export function getTradingPatternBadge(pattern: string) {
    switch (pattern) {
        case "primarily_exporter":
            return { label: "Primarily Exporter", color: "brand" as const, icon: TrendUp01 };
        case "primarily_importer":
            return { label: "Primarily Importer", color: "success" as const, icon: TrendDown01 };
        case "mixed_trader":
            return { label: "Mixed Trader", color: "warning" as const, icon: ArrowRight };
        default:
            return { label: "Unknown", color: "gray" as const, icon: ArrowRight };
    }
}

export function getVolumeTierBadge(tier: string) {
    switch (tier) {
        case "high_volume":
            return { label: "High Volume", color: "success" as const };
        case "medium_volume":
            return { label: "Medium Volume", color: "warning" as const };
        case "low_volume":
            return { label: "Low Volume", color: "gray" as const };
        default:
            return { label: "No Activity", color: "gray" as const };
    }
}
